import { Link } from "react-router-dom";

import "./DevButton.css";

const DEV_HOSTS = ["localhost", "127.0.0.1", "my.nextgis.dev"];

export function DevButton() {
  if (!DEV_HOSTS.includes(window.location.hostname)) {
    return null;
  }

  return (
    <Link to="/test" className="nolink">
      <button className="app-header__dev-btn" title="Dev test pages">
        ⚗️
      </button>
    </Link>
  );
}
